import { create } from 'zustand'

export interface IntroScreenStore {
    isIntroScreenActive: boolean
    setIsIntroScreenActive: (isIntroScreenActive: boolean) => void
}

export const useIntroScreenStore = create<IntroScreenStore>((set) => ({
    isIntroScreenActive: false,
    setIsIntroScreenActive: (isIntroScreenActive) => set({ isIntroScreenActive }),
}))
